import React, { useState } from 'react';
import { EventsTable } from 'src/domains/sportsbook/webview/components/eventsTable/EventsTable';
import { computed, makeObservable } from 'mobx';
import { EventsCollectionList } from 'src/domains/sportsbook/state/eventsCollection/EventsCollectionList';
import { observer } from 'src/utils/mobx-react';
import { EventsTableHeaderStyle } from 'src/domains/sportsbook/webview/components/eventsTable/EventsMainSectionWrapper';
import { Common, useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { EventsCollectionState } from 'src/domains/sportsbook/state/eventsCollection/EventsCollectionState';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';

class EventsStartingSoonState {
    public constructor(private readonly common: Common) {
        makeObservable(this);
    }

    @computed public get eventsCollection(): EventsCollectionList {
        return EventsCollectionState.get(this.common).listStartingSoon;
    }

    public get tableLabel(): string {
        return LanguagesState.get(this.common).getTranslation('special-box.header.starting-soon', 'Starting soon');
    }
}

interface PropsType {
    showPriceLegend: boolean;
}

export const EventsStartingSoon = observer('EventsStartingSoon', ({ showPriceLegend }: PropsType) => {
    const common = useCommon();
    const config = ConfigComponents.get(common).config;
    const [upcomingState] = useState(() => new EventsStartingSoonState(common));
    const isLoading = upcomingState.eventsCollection.isLoading;

    return (
        <EventsTable
            headerStyle={EventsTableHeaderStyle.SOLID}
            filterVersion={config.filtersVersion.startingSoon}
            icon='in-play'
            className='events-table--in-play events-table--dark'
            title={upcomingState.tableLabel}
            showHeaderSport={true}
            allGroupsOpen={true}
            eventsCollection={upcomingState.eventsCollection}
            isTogglable={true}
            showPriceLegend={showPriceLegend}
            filters={[]}
            isLoading={isLoading}
            hideNoEventsMessage={true}
            dataTest='starting-soon'
            isAmericanFootball={false}
        />
    );
});
